<template>
  <custom-tab
    content-class="mt-3"
    nav-class="nav-vue-underline"
    no-nav-style
    @input="onChangeTab"
  >
    <div class="px-md-3">
      <custom-tab-item title="Descripción del Equipo">
        <div class="bg-white rounded mt-md-4">
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-info-circle mr-2 text-orange"></i>
            <div class="color-gray-7 font-16 font-weight-bold">
              Descripción del Equipo
            </div>
          </div>
          {{ description }}
        </div>
      </custom-tab-item>
      <custom-tab-item title="Datos del Equipo">
        <div class="row my-4">
          <div class="col-12">
            <p>
              <i class="fas fa-usd-circle text-orange mr-2"></i>
              <span class="font-16">Requisición y Cotización</span>
            </p>
          </div>
          <div class="col-12 col-lg-2">
            <span class="data-title">Fecha de RFQ:</span>
            <p>{{ item.rfqDate | date }}</p>
          </div>
          <div class="col-12 col-lg-2">
            <span class="data-title">Número de RFQ:</span>
            <p>{{ item.rfqNumber | empty }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>
              <i class="fas fa-file-invoice text-orange mr-2"></i>
              <span class="font-16">Orden de Compra</span>
            </p>
          </div>
          <div class="col-12 col-lg-3">
            <span class="data-title">Número de PO:</span>
            <p>{{ item.poNumber | empty }}</p>
          </div>
          <div class="col-12 col-lg-2">
            <span class="data-title">Fecha de PO:</span>
            <p>{{ item.purchaseOrderDate | date }}</p>
          </div>
          <div class="col-12 col-lg-2">
            <span class="data-title">PO Status:</span>
            <p>{{ item.purchaseOrderStatus | empty }}</p>
          </div>
          <div class="col-12 col-lg-2">
            <span class="data-title">Suplidor:</span>
            <p>{{ item.supplier | empty }}</p>
          </div>
        </div>
      </custom-tab-item>
      <custom-tab-item title="Historial" v-if="item.hasHistory">
        <div class="bg-white rounded mt-md-4">
          <custom-history :items="statusLog" :content-style="2">
            <template v-slot:default="slotProps">
              <recommendation-status-row
                :item="slotProps.item"
              ></recommendation-status-row>
            </template>
          </custom-history>
        </div>
      </custom-tab-item>
    </div>
  </custom-tab>
</template>

<script>
import { CustomTab, CustomTabItem } from 'custom-tabs';
import CustomHistory from '@quisit/mipe-custom-history';
import equipmentService from '@/services/api/referralsandequipments.api';
import RecommendationStatusRow from '../../referralAndEquipment/components/RecommendationStatusRow';

const TABS = {
  DESCRIPTION: 0,
  ADDITIONAL_INFORMATION: 1,
  STATUS_HISTORY: 2,
};

export default {
  name: 'RequisitionRowTabs',
  components: {
    CustomTab,
    CustomTabItem,
    CustomHistory,
    RecommendationStatusRow,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    description: {
      type: String,
    },
  },
  data() {
    return {
      statusLog: [],
    };
  },
  computed: {},
  mounted() {
    this.onChangeTab(TABS.DESCRIPTION);
  },
  methods: {
    onChangeTab(key) {
      this.$emit('onTabChanged', key);
      switch (key) {
        case TABS.STATUS_HISTORY:
          this.getStatusLog();
          break;
        default:
          break;
      }
    },
    async getStatusLog() {
      const id = this.item.atServiceRecommendationId;
      const { data } = await equipmentService.getEquipmentStatusLog(id);
      this.statusLog = data;
    },
  },
};
</script>

<style lang="scss" scoped></style>
